import * as React from 'react';
import useEffect from './use_effect';
export default function useMediaQuery(query) {
  var {
    defaultMatch = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var supportsMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  var matchMedia = supportsMatchMedia ? window.matchMedia : null;
  var [match, setMatch] = React.useState(defaultMatch);
  useEffect(() => {
    if (!supportsMatchMedia || !matchMedia) {
      return undefined;
    }
    var mql = matchMedia(query);
    var supportsEventListener = 'addEventListener' in mql && 'removeEventListener' in mql;
    setMatch(mql.matches);
    var handleQueryChange = e => {
      setMatch(e.matches);
    };
    if (supportsEventListener) {
      mql.addEventListener('change', handleQueryChange);
    } else {
      // @ts-expect-error compatibility code for unknown browser
      mql.addListener(handleQueryChange);
    }
    return () => {
      if (supportsEventListener) {
        mql.removeEventListener('change', handleQueryChange);
      } else {
        // @ts-expect-error compatibility code for unknown browser
        mql.removeListener(handleQueryChange);
      }
    };
  }, [matchMedia, query, supportsMatchMedia]);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue({
      match,
      query
    });
  }
  return match;
}